export default "__VITE_ASSET__98f9f1d5__"